import React from 'react';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { MeasureInfoType, SelectDataType } from './FFTComparisonConanair';
import { GetTrendGroupTableByItemSet } from '../../../function/GroupDataModel';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import RealTimeTrendGraphGroupSelectPage from '../RealTimeTrendGraph/RealTimeTrendGraphGroupSelectPage';
import TrendGraphGroupSelectPage from '../TrendGraph/TrendGraphGroupSelectPage';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
/**ダイアログ表示モードキー */
const DialogKindKey = {
  None: 'None',
  RealTime: 'realTime',
  Trend: 'trend',
} as const;
/**ダイアログ表示タイプ */
type DialgKindType = typeof DialogKindKey[keyof typeof DialogKindKey];

/**引数 */
type Props = {
  measureInfo: MeasureInfoType[];
  getSelectDatas: () => SelectDataType[];
};

const FFTComparisonConanairButtonList: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { measureInfo } = props;

  const classes = useStyles();
  const [simpleDialogOpen, setSimpleDialogOpen] = React.useState(false);
  const [gropuSelectDialogOpen, setGropuSelectDialogOpen] = React.useState(false);

  const [dialogKind, setDialogKind] = React.useState<DialgKindType>(DialogKindKey.None);
  const [selectGroupNos, setSelectGroupNos] = React.useState<number[]>([0]);
  const [showMessage, setShowMessage] = React.useState<string>('');

  /**
   *選択データを取得
   * @param SelectDataType 画面遷移時に渡す選択データを返す
   */
  const getIsSelectData = (): SelectDataType | undefined => {
    const datas = props.getSelectDatas();
    return datas.find((row) => row.isSelect === true);
  };

  /**
   *傾向管理ボタン処理
   */
  const handleTrendPageOpen = () => {
    console.debug('★★★handleTrendPageOpen');
    const sData = getIsSelectData();
    console.debug(['selectDatas=', sData]);
    if (sData) {
      setDialogKind(DialogKindKey.Trend);
      var mes = measureInfo.find((item) => item.id === sData.mesid);
      var dev = measureInfo.find((item) => item.id === sData.devid);
      var itm = measureInfo.find((item) => item.id === sData.itemid);
      var target = measureInfo.find(
        (item) => item.KindNo === mes?.KindNo && item.DevIndex === dev?.DevIndex && item.ItemNameNo === itm?.ItemNameNo
      );
      console.debug(['selectDt=', sData, 'target', target]);
      GetTrendGroupTableByItemSet().then((ret) => {
        var gpInfo = ret.filter(
          (row) => row.trdItemSet.PLC_NO == target?.PlcNo && row.trdItemSet.SET_NO === target.SetNo
        );
        console.debug(['getgpItem=', gpInfo]);

        if (gpInfo.length !== 0) {
          var gpNos: number[] = [];
          for (var i in gpInfo) {
            gpNos.push(gpInfo[i].trdGroupSet.GROUP_NO);
          }
          setSelectGroupNos(gpNos);
          handleGroupSelectDialogShow();
        } else {
          setShowMessage(
            t('FFTComparisonConanairButtonList.グループが見つかりませんでした', 'グループが見つかりませんでした')
          );
          handleSimpleDialogClickOpen();
          return;
        }
      });
    } else {
      setShowMessage(t('FFTComparisonConanairButtonList.項目が選択されていません', '項目が選択されていません'));
      handleSimpleDialogClickOpen();
    }
  };

  /**
   * グループ選択ダイアログ表示
   */
  const handleGroupSelectDialogShow = () => {
    setGropuSelectDialogOpen(true);
  };

  /**
   * グループ選択ダイアログ閉じる
   */
  const handleGroupSelectDialogClose = () => {
    setGropuSelectDialogOpen(false);
  };

  /**
   * メッセージボックス表示
   */
  const handleSimpleDialogClickOpen = () => {
    setSimpleDialogOpen(true);
  };

  /**メッセージボックス閉じる */
  const handleSimpleDialogClose = () => {
    setSimpleDialogOpen(false);
  };

  return (
    <Grid container>
      {/* <Grid item xs={2}>
        <Button
          className={classes.buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={handleTrendPageOpen}
        >
          {t('FFTComparisonConanairButtonList.傾向管理', '傾向管理')}
        </Button>
      </Grid> */}
      <SimpleDialog
        open={gropuSelectDialogOpen}
        onClose={handleGroupSelectDialogClose}
        title={t('FFTComparisonConanairButtonList.グループ選択', 'グループ選択')}
        okText={t('FFTComparisonConanairButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        {dialogKind == DialogKindKey.RealTime ? (
          <RealTimeTrendGraphGroupSelectPage defalutGropuNos={selectGroupNos ?? []} />
        ) : (
          <TrendGraphGroupSelectPage defalutGropuNos={selectGroupNos} />
        )}
      </SimpleDialog>
      <SimpleDialog
        open={simpleDialogOpen}
        onClose={handleSimpleDialogClose}
        title={t('FFTComparisonConanairButtonList.グループ選択', 'グループ選択')}
        okText={t('FFTComparisonConanairButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        <Typography>
          <Typography>{showMessage}</Typography>
        </Typography>
      </SimpleDialog>
    </Grid>
  );
};

export default FFTComparisonConanairButtonList;
